import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationChangePageModel } from 'src/app/model/http/commons.model';

@Component({
  selector: 'app-change-page',
  templateUrl: './change-page.component.html',
  styleUrls: ['./change-page.component.scss']
})
export class ChangePageComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationChangePageModel,
    private dialogRef: MatDialogRef<ChangePageComponent>) { }

  ngOnInit(): void {
  }

  close(status: boolean): void {
    this.dialogRef.close(status);
  }
}
